import SearchPage, {
  getServerSideProps as getSearchPageServerSideProps,
} from "@/pages/search";
import { getSearchPinsByQingzhou } from "@/services";
import { getKeyWordInfo, getSeoInlinks } from "@/services/qingzhou";
import { serverSideNotFound } from "@/utils/server/serverSide";
import Head from "next/head";

export async function getServerSideProps(props) {
  const { req, params } = props;
  const { keyword } = params;

  try {
    const info = await getKeyWordInfo({
      keyword,
      category_code: "topic-pin",
    });

    const searchWord = info?.keyword;

    if (!searchWord) {
      return serverSideNotFound(props.res);
    }

    const [searchPageResult, result, inlinks] = await Promise.all([
      getSearchPageServerSideProps({
        ...props,
        path: "topic-pin",
      }),
      getSearchPinsByQingzhou({
        text: searchWord,
        page: 1,
        limit: 20,
        all_match: false,
      }),
      getSeoInlinks({
        title: `${searchWord}_${searchWord}图片-花瓣网`,
        current_url: req.url,
      }),
    ]);

    return {
      props: {
        searchWord,
        inlinks,
        serverSidePinFilters:
          searchPageResult?.props?.serverSidePinFilters || [],
        searchResult: result.pins || [],
      },
    };
  } catch (error) {
    return serverSideNotFound(props.res);
  }
}

export default function Index({
  searchWord,
  searchResult,
  serverSidePinFilters,
}) {
  return (
    <>
      <SearchPage
        query={{ type: "pin", q: searchWord }}
        searchResult={searchResult}
        serverSidePinFilters={serverSidePinFilters}
        pageInfo={{
          title: searchWord,
          desc: `${searchWord}图片灵感图，发现${searchWord}高清图片大全，一键收藏免费下载。花瓣网，设计师灵感库，素材图库分发。`,
        }}
      />
      <Head>
        <title>{`${searchWord}_${searchWord}图片下载-花瓣网`}</title>
        <meta
          name="keywords"
          content={`${searchWord},${searchWord}图片,${searchWord}模板`}
        ></meta>
        <meta
          name="description"
          content={`花瓣网为您提供${searchWord}相关图片设计灵感，更多${searchWord}相关图片、素材、设计灵感尽在花瓣网。花瓣网, 设计师寻找灵感的天堂！`}
        ></meta>
      </Head>
    </>
  );
}
